<div>
  <gstar-accordion [multiple]="true">
    @if (isAdmin() && pendingApprovedCounter()) {
      <gstar-accordion-item>
        <div accordion-header>
          <h3 class="m-0 fs-6 fw-normal">
            <ap-badge
              [value]="pendingApprovedCounter()"
              type="danger"
              styleClass="ap-bg-orange"
              size="small" />
            <span class="ap-pl-spacing-3">{{
              'notification.subtitlePendingApproval' | translate
            }}</span>
          </h3>
        </div>
        <div class="mt-3">
          <hr />
          @for (item of pendingApprovedNotifications(); track item) {
            <gstar-notification-panel-item
              [notification]="item"
              [body]="'notification.pendingApprovedMessage' | translate"
              (closeDrawer)="closeDrawer($event)" />
          }
        </div>
      </gstar-accordion-item>
    }

    <gstar-accordion-item>
      <div accordion-header>
        <h3 class="m-0 fs-6 fw-normal">
          <ap-badge
            [value]="approvedCounter()"
            type="danger"
            styleClass="ap-bg-orange"
            size="small" />
          <span class="ap-pl-spacing-3">{{
            'notification.subtitleApproval' | translate
          }}</span>
        </h3>
      </div>
      <div class="mt-3">
        <hr />
        @if (approvedCounter() !== '0') {
          <ap-button
            class="float-end"
            btnType="text"
            (click)="removeApprovedNotification()">
            {{ 'notificationPanel.removeAll' | translate }}
          </ap-button>
          @for (item of approvedNotifications(); track item) {
            <gstar-notification-panel-item
              [notification]="item"
              [body]="'notification.approvedMessage' | translate"
              (closeDrawer)="closeDrawer($event)" />
          }
        } @else {
          <div class="d-block text-body mb-1 p-2 btn-hover rounded w-100">
            <h4 class="fs-6 text-center mt-2">
              {{ 'notificationPanel.noNotifications' | translate }}
            </h4>
          </div>
        }
      </div>
    </gstar-accordion-item>
  </gstar-accordion>
</div>
